import { render, staticRenderFns } from "./MySubscriptions.vue?vue&type=template&id=382a207c&scoped=true&"
import script from "./MySubscriptions.vue?vue&type=script&lang=ts&"
export * from "./MySubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./MySubscriptions.vue?vue&type=style&index=0&id=382a207c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a207c",
  null
  
)

export default component.exports